module.exports = __webpack_public_path__ + "static/media/HPP_Integrity_Icon.c3ac213e.svg";